const getters = {
   getIsOpen: state => state.isOpen,
   getComponent: state => state.component,
   getProps: state => state.props,
}

export default getters
